module.exports = __webpack_public_path__ + "img/user.1cd50bd2.png";